
export default function AboutSection() {
  return (
    <section id="about" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight px-2">
            Experience Golf at Its Finest
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            Join us for an exclusive post-PGA Show event at the prestigious Alaqua Country Club
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          <div className="bg-emerald-50 rounded-lg p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-600 text-white rounded-full flex items-center justify-center text-2xl sm:text-3xl mb-4 sm:mb-6 mx-auto">
              <i className="ri-trophy-line"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">Championship Course</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Play on one of Florida's most exclusive and challenging championship golf courses
            </p>
          </div>

          <div className="bg-emerald-50 rounded-lg p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-600 text-white rounded-full flex items-center justify-center text-2xl sm:text-3xl mb-4 sm:mb-6 mx-auto">
              <i className="ri-team-line"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">Networking</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Connect with fellow golf enthusiasts and industry professionals in a relaxed setting
            </p>
          </div>

          <div className="bg-emerald-50 rounded-lg p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-600 text-white rounded-full flex items-center justify-center text-2xl sm:text-3xl mb-4 sm:mb-6 mx-auto">
              <i className="ri-star-line"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">Premium Experience</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Enjoy world-class amenities, exceptional service, and unforgettable memories
            </p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-6 sm:p-8 md:p-10">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">What's Included</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            <div className="flex items-start">
              <i className="ri-check-line text-emerald-600 text-xl sm:text-2xl mr-3 sm:mr-4 flex-shrink-0 mt-1"></i>
              <span className="text-sm sm:text-base text-gray-700 leading-relaxed">18 holes of championship golf at Alaqua Country Club</span>
            </div>
            <div className="flex items-start">
              <i className="ri-check-line text-emerald-600 text-xl sm:text-2xl mr-3 sm:mr-4 flex-shrink-0 mt-1"></i>
              <span className="text-sm sm:text-base text-gray-700 leading-relaxed">Golf cart</span>
            </div>
            <div className="flex items-start">
              <i className="ri-check-line text-emerald-600 text-xl sm:text-2xl mr-3 sm:mr-4 flex-shrink-0 mt-1"></i>
              <span className="text-sm sm:text-base text-gray-700 leading-relaxed">Access to the practice range before play</span>
            </div>
            <div className="flex items-start">
              <i className="ri-check-line text-emerald-600 text-xl sm:text-2xl mr-3 sm:mr-4 flex-shrink-0 mt-1"></i>
              <span className="text-sm sm:text-base text-gray-700 leading-relaxed">On-site check-in concierge service</span>
            </div>
            <div className="flex items-start">
              <i className="ri-check-line text-emerald-600 text-xl sm:text-2xl mr-3 sm:mr-4 flex-shrink-0 mt-1"></i>
              <span className="text-sm sm:text-base text-gray-700 leading-relaxed">Awards for Low Gross and Low Net</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
